import React from 'react';
// import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
// import format from 'date-fns/format';


export const CtaSection  = (props) =>  (  // use destructing to obtain function prop
    <div className="cta-section">
        <a id="cta"></a>
        <h1 className="cta-section__title">Join the Club, and Pitch In</h1>
        <h3 className="cta-section__subtitle">A Simple Event Planning / Tracking Tool that helps with Organizing Events and 
        Encourages People to Pitch In </h3> 
        <div>&nbsp;</div>
        <Link to="/signup" className="button"><p>Sign Up Free</p></Link>
    </div>
);
   
// const mapDispatchToProps = (dispatch) => ({
//     startLogin: () => dispatch(startLogin())
// })

// export default connect(undefined, mapDispatchToProps)(LoginPage);
// export default connect()(CtaSection);

export default CtaSection;




// WEBPACK FOOTER //
// ./src/components/CtaSection.js